import { SubscriptionIds } from "@sazka/lotteries/js/models/subscriptions/subscription-ids";
import { drawGamesHttpClient } from "@/lotteries/services/my-tickets/http-client";

export const useSubscription = () => {
    const getSubscriptionIds = async () => {
        const response = await drawGamesHttpClient.get<SubscriptionIds>("subscription/ids");
        return response.data;
    };

    return {
        getSubscriptionIds,
    };
};
